import React from 'react';
import {css} from "@emotion/react";
import {useAuth} from "../Auth";
import {Button} from "../Button";
import {TriGrid} from "../TriGrid";
import {useNavBar} from "../NavBar";
import {Select} from "../Select";
import {Card} from "../TabsRoute/components/Card";
import {Typography} from "../Typography";
import {TSMMonitoringContext, TSMMonitoringProvider} from "./components/TSMMonitoringProvider";
//import {CallLogsSummaryTable} from "./components/CallLogsSummaryTable";
import {CallsByState} from "./components/CallsByState";
import {IconCallList} from './components/IconCallList';
import {TSMSvg} from "../TSMAll/components/TSMSvg";
//import {Modal800CallLogs, Modal800CallLogsProps} from "./components/Modal800CallLogs";
import {DustAlerts} from "./components/DustAlerts";
import {columnTitle, columnTitleEnd, rowTitle, selectContainer} from "./styles";

import moment from "moment";
import {useCallLogsByDate, useCallLogsById} from "../../sdk/queries";
//import {ModalNotification, ModalNotificationProps} from "./components/ModalNotification";

const yearOptions = [{label: "2023", value: "2023"},
		     {label: "2024", value: "2024"},
		     {label: "2025", value: "2025"},
		     {label: "2026", value: "2026"}];

const monthOptions = [{label: "January", value: "01"}
    , {label: "February", value: "02"}
    , {label: "March", value: "03"}
    , {label: "April", value: "04"}
    , {label: "May", value: "05"}
    , {label: "June", value: "06"}
    , {label: "July", value: "07"}
    , {label: "August", value: "08"}
    , {label: "September", value: "09"}
    , {label: "October", value: "10"}
    , {label: "November", value: "11"}
    , {label: "December", value: "12"}];


export const TsmMonitoring: React.FC = () => {
    const {userRole} = useAuth();
    const {updatePage} = useNavBar();
    React.useLayoutEffect(() => {
        // Let the navbar know the current page displayed is this one
        updatePage("trackside-monitoring");
    }, []);

    const [open, setOpen] = React.useState(false);

    const [openNotification, setOpenNotification] = React.useState(false);

//    const [mode, setMode] = React.useState<NonNullable<Modal800CallLogsProps['mode']>>("view");
    const [currId, setCurrId] = React.useState<number | null>(null);


    const findYear = (year: string) => {
        return yearOptions.find(x => x.value === year);
    }

    const findMonth = (month: string) => {
        return monthOptions.find(x => x.value === month);
    }
    
    return (
        <TSMMonitoringProvider>
            <TSMMonitoringContext.Consumer>
                {({notifyCallLogsChange, selectedYear, setSelectedYear, selectedMonth, setSelectedMonth}) => (
                    <React.Fragment>
                        <Typography leftIcon={<TSMSvg/>} variant={"h1"}>Norfolk Southern High Dust Alert System</Typography>
			<TriGrid>
                        <div css={selectContainer}>
                            <Select value={findYear(selectedYear)} options={yearOptions}
                                    onChange={value => {
                                        if (value) {
                                            setSelectedYear(value.value)
                                        }
                                    }}
                            />
                        </div>
                        <div css={selectContainer}>
                            <Select value={findMonth(selectedMonth)} options={monthOptions}
                                    onChange={value => {
                                        if (value) {
                                            setSelectedMonth(value.value)
                                        }
                                    }}
                            />
                        </div>
			<Typography variant={"h3"}></Typography>
			</TriGrid>
                        <TriGrid>
			    <DustAlerts location_id={7}
		             period_s={selectedYear + "-" + selectedMonth} />
			    <DustAlerts location_id={8}
		             period_s={selectedYear + "-" + selectedMonth} />
			    <DustAlerts location_id={9}
		             period_s={selectedYear + "-" + selectedMonth} />
                        </TriGrid>
                    </React.Fragment>
                )}
            </TSMMonitoringContext.Consumer>
        </TSMMonitoringProvider>
    );
};

export default TsmMonitoring;
